import { MapContainer, TileLayer, ZoomControl } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { BASEMAPS, GLOBAL_VIEW } from "@/lib/map";
import { MapPoints } from "@/components/map/MapPoints";
import { MapFocus } from "@/components/map/MapFocus";
import { MapResize } from "@/components/map/MapResize";
import { ShakeMapLayer } from "@/components/map/ShakeMapLayer";
import { RainfallLayer } from "@/components/map/RainfallLayer";
import { CycloneLayer } from "@/components/map/CycloneLayer";
import { ReportedLayer } from "@/components/map/ReportedLayer";
import { DamLayer } from "@/components/map/DamLayer";
import { FeltQuakeLayer } from "@/components/map/FeltQuakeLayer";

export const TacticalMap = ({ points = [], onPointClick, selectedUid, viewMode = "points", focus, basemap = "satellite", shakemaps = [], onShakeSelect, rain = null, reported = [], dams = [], cyclones = [], onCycloneSelect, felt = [] }) => {
  const base = BASEMAPS[basemap];
  return (
    <div className="absolute inset-0" data-testid="tactical-map">
      <MapContainer
        center={GLOBAL_VIEW.center}
        zoom={GLOBAL_VIEW.zoom}
        minZoom={2}
        maxZoom={12}
        worldCopyJump
        zoomControl={false}
        className="h-full w-full atlas-map"
      >
        <TileLayer key={basemap} url={base.url} attribution={base.attribution} />
        {base.labels && <TileLayer key={`${basemap}-labels`} url={base.labels} opacity={0.75} />}
        {rain && <RainfallLayer meta={rain.meta} mode={rain.mode} opacity={rain.opacity} />}
        <ZoomControl position="bottomright" />
        <ShakeMapLayer events={shakemaps} onSelect={onShakeSelect} />
        <CycloneLayer storms={cyclones} onSelect={onCycloneSelect} />
        <FeltQuakeLayer quakes={felt} />
        <ReportedLayer events={reported} />
        <DamLayer corridors={dams} />
        <MapPoints points={points} selectedUid={selectedUid} onPointClick={onPointClick} heatmap={viewMode === "heatmap"} />
        <MapFocus focus={focus} />
        <MapResize />
      </MapContainer>
    </div>
  );
};
